
import ISale from "@/models/sales/isale";
import { get } from "./base-service";

const baseUrl = "sales"

export async function GetSales(year?: number): Promise<ISale[]> {

    const response = await get(`${baseUrl}/${year ? year : ""}`);

    return response.json();
}